import request from 'crm/utils/request'
import api from './api'

export async function contactWayMaterialsSettings() {
    return request(api.contactWayMaterialsSettings.url)
}

export async function contactWayMaterialsExport(payload = {}) {
    return request(api.contactWayMaterialsExport.url, {
        method: api.contactWayMaterialsExport.type,
        body: payload.body,
    })
}

export async function updateContactWayMaterialsSettings(payload) {
    return request(api.updateContactWayMaterialsSettings.url, {
        method: api.updateContactWayMaterialsSettings.type,
        body: payload.body,
    })
}
